"use strict";
/*******************************************************************************

    This is the main file for exporting classes and functions provided
    by the BOA Sodium.

    Copyright:
        Copyright (c) 2020-2021 BOSAGORA Foundation
        All rights reserved.

    License:
        ISC License. See LICENSE for details.

*******************************************************************************/
Object.defineProperty(exports, "__esModule", { value: true });
var BOASodium_1 = require("./modules/crypto/BOASodium");
Object.defineProperty(exports, "BOASodium", { enumerable: true, get: function () { return BOASodium_1.BOASodium; } });
//# sourceMappingURL=index.js.map